module.exports = __webpack_public_path__ + "static/media/filter.4578ab33.svg";